import React from "react";
import { Mail, Phone } from "lucide-react";

/**
 * MobileBottomBar — fixed bottom contact bar, visible on mobile only.
 *
 * NOTE: A phone number has not been found in the existing website content.
 * Replace the placeholder tel: link and "Call Us" label below with
 * the clinic's actual phone number before publishing.
 */
const MobileBottomBar = () => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-2xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2 h-16">
        {/* Email */}
        <a
          href="mailto:office@integroclinics.com"
          className="flex flex-col items-center justify-center gap-1 text-[#005eb8] hover:bg-[#f0f4f8] transition-colors border-r border-gray-200 active:bg-[#e0f2fe]"
          aria-label="Email Integro Clinics at office@integroclinics.com"
        >
          <Mail className="w-5 h-5" />
          <span className="text-xs font-semibold">Email</span>
        </a>

        {/* Call — replace href and label with actual phone number */}
        <a
          href="tel:+440000000000"
          className="flex flex-col items-center justify-center gap-1 text-[#005eb8] hover:bg-[#f0f4f8] transition-colors active:bg-[#e0f2fe]"
          aria-label="Call Integro Clinics"
        >
          <Phone className="w-5 h-5" />
          <span className="text-xs font-semibold">Call</span>
        </a>
      </div>
    </div>
  );
};

export default MobileBottomBar;
